import * as React from "react";
import { AxiosError } from "axios";
import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import { toast } from "react-toastify";
import { Box, Stack } from "@mui/material";

export default function ErrorPage() {
    const error = useRouteError();
    console.error(error);
    React.useEffect(() => {
        if (error instanceof AxiosError && error.response && error.response?.data?.errors && Array.isArray(error.response?.data?.errors)) {
            (error.response.data.errors as string[]).forEach(d => toast.error(d))
        }
    }, [error])
    return (
        <Box id="error-page" sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
            <Stack spacing={2}
                sx={{
                    alignItems: 'center',
                    mx: 3,
                    pb: 10,
                    mt: { xs: 8, md: 0 },
                }}>
                <h1>Oops!</h1>
                <p>Sorry, an unexpected error has occurred.</p>
                {isRouteErrorResponse(error) && <p>
                    {error.statusText}
                </p>}

            </Stack>
        </Box>
    );
}